'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../core/utils.js');

var _config = require('../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Timeout to wait for successive changes, as not to overwrite sessionStorage
// on every keypress in some form.
var TIMEOUT_MS = 400;

var WinresReservationContextService = function () {
    function WinresReservationContextService($rootScope, $timeout, $q, $filter, reservationService, destinationService, departureService, localizationService, loadingOverlayService) {
        _classCallCheck(this, WinresReservationContextService);

        this.contexts = {};
        this.contextsNonPersistent = {};
        this.watches = {};
        this.timeouts = {};

        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$filter = $filter;

        this.reservationService = reservationService;
        this.destinationService = destinationService;
        this.departureService = departureService;
        this.localizationService = localizationService;
        this.loadingOverlayService = loadingOverlayService;
        this.bookingSessionId = null;
    }

    // Watches context and saves it into the session. TIMEOUT is there so that
    // rapid successive changes (e.g. keypresses) don't trigger a save to
    // session.


    _createClass(WinresReservationContextService, [{
        key: 'initContext',
        value: function initContext(contextId) {
            var _this = this;

            this.watches[contextId] = this.$rootScope.$watch(function () {
                return _this.contexts[contextId];
            }, function () {
                if (_this.timeouts[contextId]) {
                    _this.$timeout.cancel(_this.timeouts[contextId]);
                }
                _this.timeouts[contextId] = _this.$timeout(function () {
                    delete _this.timeouts[contextId];
                    _this.saveContext(contextId);
                }, TIMEOUT_MS);
            }, true);
        }
    }, {
        key: 'setCurrentPhase',
        value: function setCurrentPhase(phase) {
            this.currentPhase = phase;
        }
    }, {
        key: 'getCurrentPhase',
        value: function getCurrentPhase() {
            return this.currentPhase;
        }

        // Returns ['Teppo Testaaja', ... ] or ['Passenger #1', ...] depending on
        // whether passenger names are entered.

    }, {
        key: 'getPassengerDisplayNames',
        value: function getPassengerDisplayNames(contextId, adultDisplayName) {
            var context = this.getContext(contextId);
            if (!context) {
                return [];
            }

            var result = [];
            var t = this.$filter('i18next');
            var passengerIndex = 1;
            _.each(context.Passengers, function (passenger) {
                if ((!passenger.FirstName || _.trim(passenger.FirstName) === '') && (!passenger.LastName || _.trim(passenger.LastName) === '')) {
                    // switch (passenger.Gender) {
                    //   case 'MR':
                    //   case 'MS':
                    //       result.push(t(adultDisplayName == null ? 'common.adult' : adultDisplayName)
                    //             + ' #' + passengerIndex);
                    //       break;
                    //   case 'CH':
                    //   case 'CH/F':
                    //   case 'CH/M':
                    //       result.push(t('common.child')
                    //             + ' #' + passengerIndex);
                    //       break;
                    //   case 'IN':
                    //   case 'IN/F':
                    //   case 'IN/M':
                    //       result.push(t('common.infant')
                    //             + ' #' + passengerIndex);
                    //       break;
                    //   default:
                    //       result.push(null);
                    // }

                    if (passenger.IsAdult) {
                        result.push(t(adultDisplayName == null ? 'common.adult' : adultDisplayName) + ' #' + passengerIndex);
                    } else if (passenger.IsChild) {
                        result.push(t('common.child') + ' #' + passengerIndex);
                    } else if (passenger.IsInfant) {
                        result.push(t('common.infant') + ' #' + passengerIndex);
                    } else result.push(null);
                } else {
                    result.push((passenger.FirstName || '') + ' ' + (passenger.LastName || ''));
                }
                passengerIndex++;
            });

            //console.log('NAMES1', result);
            passengerIndex = 0;
            for (var i = 0; i < context.NumAdults; ++i) {
                if (!result[passengerIndex]) {
                    result[passengerIndex] = t('common.adult') + ' #' + (i + 1);
                }
                passengerIndex++;
            }
            for (var i = 0; i < context.NumChildren; ++i) {
                if (!result[passengerIndex]) {
                    result[passengerIndex] = t('common.child') + ' #' + (i + 1);
                }
                passengerIndex++;
            }
            for (var i = 0; i < context.NumInfants; ++i) {
                if (!result[passengerIndex]) {
                    result[passengerIndex] = t('common.infant') + ' #' + (i + 1);
                }
                passengerIndex++;
            }
            //console.log('NAMES2', result);

            return result;
        }
    }, {
        key: 'getPassengersForPricing',
        value: function getPassengersForPricing(contextId, startDate) {
            var context = this.getContext(contextId);
            if (!context) {
                return [];
            }

            var result = [];
            var t = this.$filter('i18next');
            _.each(context.Passengers, function (passenger) {
                if (passenger.BirthDate || passenger.ArrivalAge) {
                    result.push(Object.assign({}, passenger));
                } else {
                    result.push(null);
                }
            });

            var currentIndex = 0;
            for (var i = 0; i < context.NumAdults; ++i) {
                if (!result[currentIndex]) {
                    result[currentIndex] = {
                        Gender: 'MR',
                        BirthDate: '1980-01-01'
                    };
                }
                currentIndex++;
            }

            for (var i = 0; i < context.NumChildren; ++i) {
                if (!result[currentIndex]) {
                    result[currentIndex] = {
                        Gender: 'CH',
                        BirthDate: moment(startDate).add(-2.5, 'years').format()
                    };
                }
                currentIndex++;
            }
            for (var i = 0; i < context.NumInfants; ++i) {
                if (!result[currentIndex]) {
                    result[currentIndex] = {
                        Gender: 'IN',
                        BirthDate: moment(startDate).add(-1, 'years').format()
                    };
                }
                currentIndex++;
            }

            var numPassengers = context.NumAdults + context.NumChildren + context.NumInfants;

            return result;
        }
    }, {
        key: 'getOrCreateDummyPassengers',
        value: function getOrCreateDummyPassengers(contextId, eventDate, passengerAmounts, childrenAges) {
            var context = this.getContext(contextId);
            if (!context) {
                console.warn('[RCS] No context with ID:', contextId);
                return [];
            }

            if (!context.Passengers) {
                context.Passengers = [];
            }

            var adults = this.getOrCreatePassengersBetweenAges(context, eventDate, 'MR', passengerAmounts.adults, 18, 1000, 20);
            console.log('[RCS] Got', adults.length, 'adults.');

            var children = [];
            if (childrenAges && childrenAges.length === passengerAmounts.children) {
                console.log('[RCS] Children to find:', childrenAges);
                children = this.getOrCreateChildPassengersWithAges(context, eventDate, childrenAges);
                console.log('[RCS] Got', children.length, 'children with actual ages.');
            } else {
                children = this.getOrCreatePassengersBetweenAges(context, eventDate, 'CH', passengerAmounts.children, 2, 18, 11);
                console.log('[RCS] Got', children.length, 'children with proto ages.');
            }

            var infants = this.getOrCreatePassengersBetweenAges(context, eventDate, 'IN', passengerAmounts.infants, 0, 2, 1);
            console.log('[RCS] Got', infants.length, 'infants.');

            return adults.concat(children).concat(infants);
        }

        // Return indexes of child passengers with ages matching _childrenAges_.
        // If no matching passenger is found, one is created.

    }, {
        key: 'getOrCreateChildPassengersWithAges',
        value: function getOrCreateChildPassengersWithAges(context, eventDate, childrenAges) {
            var _this2 = this;

            var existingChildIndexes = this.getChildPassengerIndexes(context);

            var age = function age(passengerIndex) {
                var passenger = context.Passengers[passengerIndex];
                if (!passenger.BirthDate) return undefined;
                var birthDate = moment(passenger.BirthDate);
                return eventDate.diff(birthDate, 'years', false);
            };

            return _.map(childrenAges, function (child) {
                var childIndex = _.find(existingChildIndexes, function (i) {
                    return age(i) === child.Age;
                });
                if (childIndex === undefined) {
                    childIndex = _this2.createChildPassengerWithAge(context, eventDate, child.Age);
                } else {
                    existingChildIndexes.remove(childIndex);
                }
                return childIndex;
            });
        }
    }, {
        key: 'getChildPassengerIndexes',
        value: function getChildPassengerIndexes(context) {
            var indexes = [];
            _.each(context.Passengers, function (passenger, index) {
                if (passenger.Gender === 'CH') {
                    indexes.push(index);
                }
            });
            return indexes;
        }
    }, {
        key: 'createChildPassengerWithAge',
        value: function createChildPassengerWithAge(context, eventDate, age) {
            var birthDate = eventDate.clone().subtract(age, 'years');
            return this.createPassenger(context, 'CH', birthDate);
        }

        // Get indexes of _amount_ passengers who are at least _startAge_ years old
        // and under _endAge_ years old on _eventDate_.
        // If there aren't enough passengers, create enough new ones. The created
        // passengers will have their date of birth set such that they will be
        // _protoAge_ years old on _eventDate_.

    }, {
        key: 'getOrCreatePassengersBetweenAges',
        value: function getOrCreatePassengersBetweenAges(context, eventDate, gender, amount, startAge, endAge, protoAge) {
            var startDate = eventDate.clone().subtract(endAge, 'years');
            var endDate = eventDate.clone().subtract(startAge, 'years');
            var protoDate = eventDate.clone().subtract(protoAge, 'years');
            console.log('[RCS] Finding', amount, 'passengers born after', startDate.format(), 'and before or on', endDate.format(), 'or matching', gender);

            var existing = [];
            _.each(context.Passengers, function (passenger, index) {
                if (passenger.BirthDate) {
                    var birthDate = moment(passenger.BirthDate);
                    if (birthDate.isAfter(startDate) && birthDate.isSameOrBefore(endDate)) {
                        existing.push(index);
                    }
                } else if (passenger.Gender == gender) {
                    existing.push(index);
                }
            });

            var extrasNeeded = Math.max(0, amount - existing.length);
            var extras = [];
            for (var i = 0; i < extrasNeeded; ++i) {
                var index = this.createPassenger(context, gender, protoDate);
                extras.push(index);
            }

            return existing.concat(extras);
        }
    }, {
        key: 'createPassenger',
        value: function createPassenger(context, gender, birthDate) {
            var index = context.Passengers.length;
            var passenger = {
                Gender: gender,
                BirthDate: birthDate.format('Y-MM-DD')
            };
            context.Passengers.push(passenger);
            console.log('[RCS] Created passenger', index, ':', passenger);
            return index;
        }
    }, {
        key: 'isReturnFromBank',
        value: function isReturnFromBank() {
            return !!(0, _utils.getParameter)("bookingSessionId");
        }
    }, {
        key: 'confirmBookingByInvoice',
        value: function confirmBookingByInvoice(contextId) {
            var _this3 = this;

            this.loadingOverlayService.start();
            // Confirm the reservation with the payment result.
            return this.reservationService.confirmBookingByInvoice(this.contexts[contextId], this.localizationService.getLanguage()).then(function (result) {
                _this3.loadingOverlayService.stop();
                _this3.currentPhase = "thankyou";
                _this3.reservationResult = result;
                _this3.$rootScope.$broadcast('confirmBooking', result);
                return result;
            });
        }
        // Gets the reservation if already reserved (paid). Returns promise that
        // resolves with the paymentResult. If not returning from payment, the
        // returned promise will always be rejected.
        // ALSO UPDATES CURRENT PHASE (IF IN CONFIRMATION)

    }, {
        key: 'handleReturnFromBank',
        value: function handleReturnFromBank() {
            var _this4 = this;

            // Check if bank was canceled.
            if ((0, _utils.getParameter)('cancel') || (0, _utils.getParameter)('reject')) {
                return this.$q(function (resolve) {
                    return resolve('cancel');
                });
            }

            var bookingSessionId = (0, _utils.getParameter)("bookingSessionId");
            if (!bookingSessionId || this.bookingSessionId == bookingSessionId) {
                // Return an always rejected promise.
                // The message "Did not return from bank" is used in handlig the error in contextDirective
                return this.$q(function (resolve, reject) {
                    return reject("Did not return from bank");
                });
            }

            this.bookingSessionId = bookingSessionId;

            this.loadingOverlayService.start();

            // Confirm the reservation with the payment result.
            return this.reservationService.confirmBookingByReturnUrl("" + window.location).then(function (result) {
                if (result.OriginalOkUrl) {
                    // Remove HOST
                    var path = result.OriginalOkUrl.replace(/https?:\/\/[^\/]*/, '');
                    //Remove GET param bookingSessionId (it is set by frontend code,
                    //not by bank, thus is included in the original OK url too.)
                    path = path.replace(/bookingSessionId=[^&]*&?/, '');
                    if (!path) {
                        path = '/';
                    }
                    // Old IE does not support replaceState
                    if (window.history && window.history.replaceState) {
                        window.history.replaceState(result, $('title').text(), path);
                    }
                }
                _this4.loadingOverlayService.stop();
                _this4.currentPhase = "thankyou";
                _this4.reservationResult = result;
                _this4.$rootScope.$broadcast('confirmBooking', result);
                return result;
            });
        }

        // Gets the reservation result if the booking was made in this request.
        // It is possible that the reservation data is not initially available
        // because a request is still being made.

    }, {
        key: 'getConfirmBookingResult',
        value: function getConfirmBookingResult() {
            return this.reservationResult;
        }
    }, {
        key: 'setReservationTermsOpener',
        value: function setReservationTermsOpener(opener) {
            this.reservationTermsOpener = opener;
        }
    }, {
        key: 'getReservationTermsOpener',
        value: function getReservationTermsOpener() {
            return this.reservationTermsOpener;
        }
    }, {
        key: 'getContext',
        value: function getContext(contextId) {
            if (!this.contexts[contextId]) {
                var contextJSON = window.sessionStorage.getItem('winresReservationContext-' + contextId);

                if (contextJSON) {
                    this.contexts[contextId] = JSON.parse(contextJSON);
                    this.initContext(contextId);
                }
            }

            // const con = this.contexts[contextId];
            // if (con && con.Products) {
            //     console.log('Context', contextId, 'products length:', con.Products.length);
            // }

            // // comment out this when using the debugging code below
            return this.contexts[contextId];

            // // DEBUG TOOL
            // // Debugging what changes the context with javascript Proxy
            // // When debugging you should uncomment this debugging code
            // // and comment out the normally used ' return this.contexts[contextId]; '
            // //
            // // we have a check because proxy cannot be created if target is undefined
            // if (this.contexts[contextId]) {
            //      var proxyContext = new Proxy(this.contexts[contextId], {
            //          set (obj, prop, value) {
            //              if (prop == "Products") {
            //                  console.trace("====> CONTEXT prop '" + prop + "' WAS MODIFIED! " + prop +  "  is: ", JSON.parse(JSON.stringify(obj[prop]) ) ) ;

            //              }
            //              obj[prop] = value;
            //              return true;
            //          }
            //      });
            //      return proxyContext;
            //  } else {
            //      return this.contexts[contextId];
            //  }
        }
    }, {
        key: 'getContextNonPersistent',
        value: function getContextNonPersistent(contextId) {
            if (!this.contextsNonPersistent[contextId]) {
                this.contextsNonPersistent[contextId] = {};
            }
            return this.contextsNonPersistent[contextId];
        }
    }, {
        key: 'deleteContext',
        value: function deleteContext(contextId) {
            delete this.contexts[contextId];
            delete this.contextsNonPersistent[contextId];
            window.sessionStorage.removeItem('winresReservationContext-' + contextId);
        }
    }, {
        key: 'saveContext',
        value: function saveContext(contextId) {
            var contextJSON = JSON.stringify(this.contexts[contextId]);
            window.sessionStorage.setItem('winresReservationContext-' + contextId, contextJSON);
        }
    }, {
        key: 'createContext',
        value: function createContext(contextId, data) {
            this.contexts[contextId] = data;
            this.initContext(contextId);
        }

        // See reservationComponentDirective.js (same function) for complete
        // documentation.

    }, {
        key: 'setReservationComponentErrors',
        value: function setReservationComponentErrors(contextId, componentName, subName, errors) {
            var context = this.getContextNonPersistent(contextId);
            if (!context.reservationComponentErrors) {
                context.reservationComponentErrors = {};
            }
            if (!context.reservationComponentErrors[componentName]) {
                context.reservationComponentErrors[componentName] = {};
            }
            context.reservationComponentErrors[componentName][subName] = errors;

            // Update error status here to make ng-model digesting faster.
            this.updateErrorStatus(context);
        }
    }, {
        key: 'updateErrorStatus',
        value: function updateErrorStatus(context) {
            var errorCount = 0;

            _.each(context.reservationComponentErrors, function (errorsBySubName) {
                _.each(errorsBySubName, function (errors) {
                    errorCount += errors.length;
                });
            });

            context.hasReservationComponentErrors = errorCount > 0;
        }
    }, {
        key: 'hasErrors',
        value: function hasErrors(contextId) {
            var context = this.getContextNonPersistent(contextId);
            return context.hasReservationComponentErrors;
        }
    }, {
        key: 'getErrors',
        value: function getErrors(contextId, componentName) {
            var context = this.getContextNonPersistent(contextId);
            if (!context.reservationComponentErrors) {
                return [];
            }
            var result = [];

            // Get errors by component name.
            if (componentName) {
                _.each(context.reservationComponentErrors[componentName], function (errors) {
                    _.each(errors, function (error) {
                        if (typeof error === 'string') {
                            result.push({ Message: error, Params: {} });
                        } else {
                            result.push(error);
                        }
                    });
                });
            } else {
                _.each(context.reservationComponentErrors, function (errorsBySubName, componentName) {
                    _.each(errorsBySubName, function (errors) {
                        _.each(errors, function (error) {
                            if (typeof error === 'string') {
                                result.push({ Message: error, Params: {} });
                            } else {
                                result.push(error);
                            }
                        });
                    });
                });
            }
            return result;
        }
    }, {
        key: 'getPhaseErrors',
        value: function getPhaseErrors(contextId, phase) {
            var errors = this.getErrors(contextId, phase);
            // errors = errors.concat(_.filter(this.getErrors(contextId), error=>{
            //     return error.Message && error.Message.indexOf(phase)>-1
            // }));
            return errors;
        }
    }, {
        key: 'loadDestinationIntoContext',
        value: function loadDestinationIntoContext(context, destinationCode, options) {
            var _this5 = this;

            var language = this.localizationService.getLanguage();
            return this.loadDestination(destinationCode, language).then(function (destination) {
                _.each(destination.PassengerFieldSettings, function (field, fieldName) {
                    if (fieldName == 'Gender' && options.forceGender) {
                        field.Ask = false;
                        field.Required = false;
                    }
                    var t = _this5.getFieldTitleOverride(options, fieldName);
                    if (t) {
                        field.Title = t;
                    }
                });
                context.Destination = destination;
                return destination;
            });
        }
    }, {
        key: 'loadDepartureIntoContext',
        value: function loadDepartureIntoContext(context, destinationCode, startDate, endDate, getCapacity) {
            var language = this.localizationService.getLanguage();
            return this.loadDeparture(destinationCode, startDate, endDate, language, getCapacity).then(function (departure) {
                context.SelectedDeparture = departure;
                return departure;
            });
        }
    }, {
        key: 'getFieldTitleOverride',
        value: function getFieldTitleOverride(options, fieldName) {
            if (fieldName == 'CompanyName') {
                fieldName = 'Company';
            }
            return options['fieldTitle' + fieldName] ? options['fieldTitle' + fieldName] : null;
        }
    }, {
        key: 'rebuildPassengerFields',
        value: function rebuildPassengerFields(context, passengerFieldsBase, customFieldsPrepend, customFieldsAppend) {
            if (context.Destination && context.Destination.PassengerFieldSettings) {
                //console.log('ACTUALLY REBUILDING2', customFieldsPrepend, passengerFieldsBase, customFieldsAppend);
                context.passengerFields = customFieldsPrepend.concat(passengerFieldsBase, customFieldsAppend);
                context.passengerFieldSettings = _.clone(context.Destination.PassengerFieldSettings);

                _.each(customFieldsPrepend, function (field) {
                    context.passengerFieldSettings[field.Name] = field;
                });
                _.each(customFieldsAppend, function (field) {
                    context.passengerFieldSettings[field.Name] = field;
                });

                //Allowed values convert from ['Hello'] => [{Key: "Hello", Title: "Hello"}]
                _.each(context.passengerFieldSettings, function (field) {
                    // Note that winresReservationCustomSelect alters AllowdValues in
                    // real time, thus cannot just replace the allowed values for them.
                    if (field.AllowedValues && field.AllowedValues.length > 0 && typeof field.AllowedValues[0] === 'string') {
                        field.AllowedValues = _.map(field.AllowedValues, function (value) {
                            return typeof value == 'string' ? { Key: value, Title: value } : value;
                        });
                    }
                });
            }
        }
    }, {
        key: 'loadDestination',
        value: function loadDestination(destinationCode, language) {
            var cachedDestination = this.loadCachedDestination(destinationCode, language);
            if (cachedDestination) {
                // console.log('[WRCS] Found destination in cache:', destinationCode, language);
                return this.$q(function (resolve, reject) {
                    return resolve(cachedDestination);
                });
            } else {
                // console.log('[WRCS] Destination not in cache, fetching from backend:', destinationCode, language);
                return this.loadDestinationFromBackendAndCacheIt(destinationCode, language);
            }
        }
    }, {
        key: 'loadDeparture',
        value: function loadDeparture(destinationCode, startDate, endDate, language, getCapacity) {
            var cachedDeparture = this.loadCachedDeparture(destinationCode, startDate, endDate, language);
            if (cachedDeparture) {
                // console.log('[WRCS] Found destination in cache:', destinationCode, language);
                return this.$q(function (resolve, reject) {
                    return resolve(cachedDeparture);
                });
            } else {
                // console.log('[WRCS] Destination not in cache, fetching from backend:', destinationCode, language);
                return this.loadDepartureFromBackendAndCacheIt(destinationCode, startDate, endDate, language, getCapacity);
            }
        }
    }, {
        key: 'loadDestinationFromBackendAndCacheIt',
        value: function loadDestinationFromBackendAndCacheIt(destinationCode, language) {
            var _this6 = this;

            var result = this.destinationService.getWinresDestination(destinationCode, language);
            return result.then(function (destination) {
                _this6.cacheDestination(destinationCode, language, destination);
                // console.log('[WRCS] Destination cached:', destinationCode, language);
                return destination;
            });
        }
    }, {
        key: 'loadDepartureFromBackendAndCacheIt',
        value: function loadDepartureFromBackendAndCacheIt(destinationCode, startDate, endDate, language, getCapacity) {
            var _this7 = this;

            var result = this.departureService.getWinresDeparture(destinationCode, startDate, endDate, language, getCapacity);
            return result.then(function (departure) {
                _this7.cacheDeparture(destinationCode, startDate, endDate, language, departure);
                // console.log('[WRCS] Destination cached:', destinationCode, language);
                return departure;
            });
        }
    }, {
        key: 'cacheDestination',
        value: function cacheDestination(destinationCode, language, destination) {
            var now = new Date();
            var record = {
                validUntil: now.getTime() + _config.destinationCacheTimeMs,
                destination: destination
            };
            var json = JSON.stringify(record);
            var key = this.destinationKey(destinationCode, language);
            window.sessionStorage.setItem(key, json);
        }
    }, {
        key: 'cacheDeparture',
        value: function cacheDeparture(destinationCode, startDate, endDate, language, departure) {
            var now = new Date();
            var record = {
                validUntil: now.getTime() + _config.destinationCacheTimeMs,
                departure: departure
            };
            var json = JSON.stringify(record);
            var key = ['departure', destinationCode, startDate, endDate, language].join('::');
            window.sessionStorage.setItem(key, json);
        }
    }, {
        key: 'loadCachedDestination',
        value: function loadCachedDestination(destinationCode, language) {
            if (!_config.destinationCacheTimeMs) {
                return null;
            }
            var key = this.destinationKey(destinationCode, language);
            var json = window.sessionStorage.getItem(key);
            if (!json) return null;
            var record = JSON.parse(json);
            if (this.isExpired(record)) {
                window.sessionStorage.removeItem(key);
                return null;
            }
            return record.destination;
        }
    }, {
        key: 'loadCachedDeparture',
        value: function loadCachedDeparture(destinationCode, startDate, endDate, language) {
            if (!_config.destinationCacheTimeMs) {
                return null;
            }
            var key = ['departure', destinationCode, startDate, endDate, language].join('::');
            var json = window.sessionStorage.getItem(key);
            if (!json) return null;
            var record = JSON.parse(json);
            if (this.isExpired(record)) {
                window.sessionStorage.removeItem(key);
                return null;
            }
            return record.destination;
        }
    }, {
        key: 'isExpired',
        value: function isExpired(record) {
            var now = new Date().getTime();
            return now > record.validUntil;
        }
    }, {
        key: 'destinationKey',
        value: function destinationKey(destinationCode, language) {
            return 'winresReservationContext-Destination-' + language + '-' + destinationCode;
        }
    }]);

    return WinresReservationContextService;
}();

WinresReservationContextService.$inject = ['$rootScope', '$timeout', '$q', '$filter', 'reservationService', 'destinationService', 'departureService', 'localizationService', 'loadingOverlayService'];

_module3.default.service('winresReservationContextService', WinresReservationContextService);


//////////////////
// WEBPACK FOOTER
// ./src/reservation/reservationContextService.js
// module id = 552
// module chunks = 2